import { createSlice } from '@reduxjs/toolkit';
import { getResult } from '../thunks/resultThunk';

const initialState = {
  list: [],
  total: 0,
  loading: false,
  error: null,
};

const resultSlice = createSlice({
  name: 'result',
  initialState,
  reducers: {
    setData(state, action) {
      state.list = action.payload.data;
      state.total = action.payload.total;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getResult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getResult.fulfilled, (state, action) => {
        state.list = action.payload.data;
        state.total = action.payload.total;
        state.loading = false;
      })
      .addCase(getResult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setData } = resultSlice.actions;
export default resultSlice.reducer;